import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Box, CssBaseline, Stack } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

import { UserContextProvider } from '@/contexts/userContext';
import AppBar from './components/appBar/appBar';
import Footer from './components/footer';
import { ApiContextProvider } from './contexts/apiContext';
import { HttpClientProvider } from './contexts/httpClientContext';
import { NotificationContextProvider } from './contexts/notificationContext';
import { DomainContextProvider } from './contexts/domainContext';
import Routing from './routes/routing';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const fullsreen = queryParams.get('fullscreen') === 'true';

  library.add(fas, far);

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
      <BrowserRouter>
        <CssBaseline />
        <UserContextProvider>
          <HttpClientProvider>
            <ApiContextProvider>
              <NotificationContextProvider>
                <DomainContextProvider>
                  <Stack sx={{ height: '100%' }}>
                    {!fullsreen && <AppBar />}

                    <Box
                      sx={{
                        width: '100%',
                        padding: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        alignSelf: 'stretch',
                        flexGrow: 1,
                      }}
                    >
                      <Routing />
                    </Box>

                    {!fullsreen && <Footer />}
                  </Stack>
                </DomainContextProvider>
              </NotificationContextProvider>
            </ApiContextProvider>
          </HttpClientProvider>
        </UserContextProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
